/**
 * What a pet is doing in the clinic RIGHT NOW, derived by the backend from the consultation it
 * currently has open (see `PatientClinicalStates` on the .NET side -- these are the same wire
 * values, so they must not be renamed on one side alone).
 *
 * `null` -- no open visit -- is the answer for all but a handful of pets at any moment (measured on
 * the live tenant: 1 open consultation against 25.109 active patients), which is why the grid shows
 * this as a badge that appears rather than as a column that is nearly always empty.
 */
export type PatientClinicalStatus =
  | 'hospitalized'
  | 'waiting-room'
  | 'in-consultation'
  | 'ready-for-discharge';

const CLINICAL_STATUSES: readonly PatientClinicalStatus[] = [
  'hospitalized',
  'waiting-room',
  'in-consultation',
  'ready-for-discharge',
];

/**
 * Narrows the backend's raw string, defaulting to `null` for anything unrecognised. A new state
 * added on the backend therefore shows no badge here instead of rendering a missing translation
 * key -- the mapper never trusts the wire value blindly.
 */
export function toPatientClinicalStatus(value: string | null | undefined): PatientClinicalStatus | null {
  return CLINICAL_STATUSES.find((status) => status === value) ?? null;
}
